import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, tap } from 'rxjs';
import { TranslationCoreService } from '../services/translation-core.service';
import { TranslationCoreActions } from './translation-core.actions';

@Injectable()
export class TranslationCoreEffects {
  getTranslationsSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TranslationCoreActions.getTranslationsSuccess),
      map(() => {
        return TranslationCoreActions.saveTranslationsToCache();
      })
    )
  );

  saveTranslationsToCache$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(TranslationCoreActions.saveTranslationsToCache),
        tap(() => this.translationCoreService.saveTranslationToCache()),
        catchError(error =>
          of(TranslationCoreActions.saveTranslationsToCacheError({ error }))
        )
      ),
    { dispatch: false }
  );

  setLanguage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TranslationCoreActions.setLanguage),
      map(() => TranslationCoreActions.saveTranslationsToCache())
    )
  );

  constructor(
    private actions$: Actions,
    private translationCoreService: TranslationCoreService
  ) {}
}
